/**
 * Sentinel written into a model property when a form input is left blank on
 * purpose. Backs the `enableNotValues` attribute available on the Text, Date,
 * DateTime, List and NumberPad input methods since form definition 3.4.0.
 *
 * Originally defined alongside the NEMSIS demographic models, which is where
 * the pattern came from; it is not NEMSIS-specific and outlived that feature.
 */
export enum NaValues {
    NOT_APPLICABLE = 'NOT_APPLICABLE',
}
